// Stores
import { useUiStore } from '@stores/ui';

// Personal lib
import { UpdateServiceNameEnum } from './common/update-service-enum';
import { UpdateService } from './common/update-service.class';
import { logger } from '@shared/lib/logger/logger-manager';
import configRepository from '@data/repository/config.repository';
import changelogRepository from '@data/repository/changelog.repository';
import { RepositoryStrategyEnum } from '@shared/enum/repository-strategy.enum';
import { IChangelog } from '@shared/interface/model.interface';

export class UpdateManagerUi {
  /**
   * UpdateManagerUi : get all config
   */
  static readonly UiConfigAll = class UpdateServiceConfigAll extends UpdateService {
    updateServiceName = UpdateServiceNameEnum.CONFIG_ALL;

    /**
     * Cron store of cron task
     */
    private uiStore = useUiStore();

    task(forcedStrategy?: RepositoryStrategyEnum) {
      return configRepository
        .getConfig(forcedStrategy)
        .then((rslt) => {
          this.uiStore.config = rslt;

          return rslt;
        })
        .catch((err) => logger?.info('getConfig - err : ', err.message));
    }
  };

  /**
   * UpdateManagerUi : get changelog
   */
  static readonly UiChangelog = class UpdateServiceChangelog extends UpdateService {
    updateServiceName = UpdateServiceNameEnum.CHANGELOG;

    /**
     * Cron store of cron task
     */
    private uiStore = useUiStore();

    task(forcedStrategy?: RepositoryStrategyEnum): Promise<IChangelog | undefined> {
      return changelogRepository
        .getChangelog(forcedStrategy)
        .then((changelog) => {
          this.uiStore.changelog = changelog;

          return changelog;
        })
        .catch((err) => {
          logger?.info('getChangelog - err : ', err.message)
          return undefined
        });
    }
  };
}
